module.exports = __webpack_public_path__ + "img/performance-graph-no-data.5c0f7dbb.svg";